import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const query = `
        mutation (
            $hostBannerTitle1: String,
            $hostBannerContent1: String,
            $hostBannerImage1: String,
            $hostBannerImage2: String,
            $hostBannerContent2: String,
            $buttonLabel: String,
            $buttonLabel2: String,
            $dynamicWhyHostInfoBlock: String
        ) {
            updateWhyHostPage(
                hostBannerTitle1: $hostBannerTitle1,
                hostBannerContent1: $hostBannerContent1,
                hostBannerImage1: $hostBannerImage1,
                hostBannerImage2: $hostBannerImage2,
                hostBannerContent2: $hostBannerContent2,
                buttonLabel: $buttonLabel,
                buttonLabel2: $buttonLabel2,
                dynamicWhyHostInfoBlock: $dynamicWhyHostInfoBlock
            ) {
                status
                errorMessage
            }
        }
    `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
      variables: {
        hostBannerTitle1: values.dynamicWhyHostInfoBlock[0].hostBannerTitle1,
        hostBannerContent1: values.dynamicWhyHostInfoBlock[0].hostBannerContent1,
        hostBannerImage1: values.hostBannerImage1,
        hostBannerImage2: values.hostBannerImage2,
        hostBannerContent2: values.dynamicWhyHostInfoBlock[0].hostBannerContent2,
        buttonLabel: values.dynamicWhyHostInfoBlock[0].buttonLabel,
        buttonLabel2: values.dynamicWhyHostInfoBlock[0].buttonLabel2,
        dynamicWhyHostInfoBlock: JSON.stringify(values.dynamicWhyHostInfoBlock),
      },
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateWhyHostPage?.status === 'success') {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' });
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' });
  }
}

export default submit;